// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import { mergeClasses } from 'util/commons';
import styles from './StackedRadiosGroup.module.scss';

export type StackedRadiosGroupOption = {
  label: React.ReactNode;
  value: string;
};

type StackedRadiosGroupProps = {
  options: StackedRadiosGroupOption[];
  value?: string;
  onChange?: (value: string) => void;
  classNames?: {
    wrapper?: string;
    item?: string;
    active?: string;
  };
};

const StackedRadiosGroup: React.FC<StackedRadiosGroupProps> = ({
  options,
  value,
  onChange,
  classNames,
}) => {
  if (!options.length) {
    return null;
  }

  return (
    <div className={mergeClasses(styles.wrapper, classNames?.wrapper)}>
      {options.map(({ label, value: optionValue }, index) => (
        <div
          key={index}
          className={mergeClasses(styles.item, classNames?.item, {
            [styles.active]: value === optionValue,
            [classNames?.active || '']: value === optionValue,
          })}
          onClick={() => {
            if (optionValue !== value) {
              onChange?.(optionValue);
            }
          }}
        >
          {label}
        </div>
      ))}
    </div>
  );
};

export default StackedRadiosGroup;
